module.exports = __webpack_public_path__ + "static/media/fluent_print-32-filled.5e82aa6b.svg";